import { useState } from "react";

export const BigPick = () => {
    const [showPick, setShowPick] = useState(false);

    const toggleShowPick = () => {
        setShowPick(!showPick);
    };

    return (
        <>
            <section className="pt-3 pb-3 text-center bg-dark">
                <button onClick={toggleShowPick} className="btn btn-primary">
                    Big Pick Little Pick
                </button>
                <div
                    className={`container pt-3 pb-3 ${
                        showPick ? "" : "d-none"
                    }`}
                >
                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            <div className="ratio ratio-16x9">
                                <iframe
                                    className="border border-3"
                                    src="https://www.youtube-nocookie.com/embed/MPBsnCuvGHI?si=qEPN-n3pgJYfWy4O"
                                    title="YouTube video player"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
